import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialStat: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 1.52h-1.53V0H3.05v1.52H1.52v1.53H0v25.9h1.52v1.53h1.53V32h25.9v-1.52h1.53v-1.53H32V3.05h-1.52Zm0 15.24h-1.53v10.67h-1.52v1.52H4.57v-1.52H3.05V16.76H1.52v-1.52h1.53V4.57h1.52V3.05h22.86v1.52h1.52v10.67h1.53Z\"/><path fill=\"currentColor\" d=\"M24.38 15.24h4.57v1.52h-4.57Zm-1.52-1.53h1.52v1.53h-1.52Zm-1.53 1.53h1.53v3.05h-1.53Zm-1.52 3.05h1.52v3.04h-1.52Zm-1.52 3.04h1.52v1.53h-1.52Zm-1.53-3.04h1.53v3.04h-1.53Zm-1.52-3.05h1.52v3.05h-1.52Zm-1.53-3.05h1.53v3.05h-1.53Zm-1.52-3.05h1.52v3.05h-1.52Zm-1.52-1.52h1.52v1.52h-1.52ZM9.14 9.14h1.53v3.05H9.14Zm-1.52 3.05h1.52v3.05H7.62Zm-4.57 3.05h4.57v1.52H3.05Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialStat
